var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-list"},[_c('div',{staticClass:"text"},[_vm._v("\n    No questions for this lecture\n  ")]),_vm._v(" "),_c('div',{staticClass:"action-btn"},[_c('ButtonArrow',{staticClass:"button-arrow accent",attrs:{"text":"Ask a question","type":"div"},on:{"click":_vm.ask}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }